import { memo, useCallback, useEffect, useState } from 'react';

import { GatsbyImage } from 'gatsby-plugin-image';

import Button from '@/components/atoms/button/button';
import { IShiftRequestResultProps } from '@/interfaces/qanty';
import { convertTimeSeconds } from '@/utils/convertTimeSeconds';
import './shiftRequestResult.scss';

const MemoShiftRequestResult = ({
  turnText,
  textTimerStatus,
  image,
  shiftInfoTitle,
  shiftInfoSubtitle,
  listContent,
  listResponse,
  ticketsOnFront,
  onClickPrevious,
  onClickNext,
  loaderAccept,
  ticketId,
}: IShiftRequestResultProps) => {
  const statusShift = () => {
    if (listResponse.success) {
      return 'Solicitud activa';
    }
    return 'Solicitud finalizada';
  };

  const [timer, setTimer] = useState(
    listResponse.info?.wait_metrics?.waiting_time ||
      listResponse.info?.wait_metrics?.wait_estimate ||
      0,
  );

  const [finishTimer, setFinishTimer] = useState(false);

  const convertTimeInterval = useCallback(() => {
    return setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
        return;
      }
      setFinishTimer(true);
    }, 1000);
  }, [timer]);

  useEffect(() => {
    const interval = convertTimeInterval();

    if (timer === 0) {
      setFinishTimer(true);
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [finishTimer, timer]);

  return (
    <div className="o-shift-request-result">
      <article className="o-shift-request-result__card">
        <figure className="o-shift-request-result__image">
          <GatsbyImage
            image={image.gatsbyImage[0]}
            alt={image.title}
            title={image.title}
            loading="eager"
          />
        </figure>
        <p>
          <span className="o-shift-request-result__text">{turnText}</span>
          <span className="o-shift-request-result__name">{listResponse.info.name}</span>
        </p>
        <p className="o-shift-request-result__cardOne">
          <span className="o-shift-request-result__request">{statusShift()}</span>
        </p>
        <p>
          <span className="o-shift-request-result__timer">
            {timer > 120 ? textTimerStatus : ''}
          </span>
          <span className="o-shift-request-result__timer --number">
            {timer > 120
              ? convertTimeSeconds(timer)
              : 'Tu turno esta proximo a ser llamado, acercate a la sede lo mas pronto posible'}
          </span>
        </p>
      </article>
      <article className="o-shift-request-result__card cardTwo">
        <h2 className="o-shift-request-result__title">{shiftInfoTitle}</h2>
        <p className="o-shift-request-result__subtitle">{shiftInfoSubtitle}</p>
        <hr className="o-shift-request-result__line" />
        <aside className="o-shift-request-result__listInfo">
          <p>
            <span className="header">{listContent.lista[0]}</span>
            <span className="content">{ticketsOnFront}</span>
          </p>
          <p>
            <span className="header">{listContent.lista[1]}</span>
            <span className="content">{listResponse.info?.branch.name} </span>
            <span className="content address">{listResponse.info?.branch?.address}</span>
          </p>
          <p>
            <span className="header">{listContent.lista[2]}</span>
            <span className="content">{listResponse.info.current_line.name}</span>
          </p>
        </aside>
        <aside className="o-shift-request-result__buttons">
          {!ticketId &&
            (listContent?.boton[1] ? (
              <Button
                type="button"
                classname="one"
                text={listContent.boton[1].copy}
                onClickAction={onClickNext}
                isDisabled={false}
                loader={loaderAccept}
              />
            ) : (
              <Button
                type="button"
                classname="one"
                text="Tomar turno"
                onClickAction={onClickNext}
                isDisabled={false}
                loader={loaderAccept}
                gtmMark="gtmClickBotonCancelarTurnoPresencial"
              />
            ))}

          <button type="button" className="two" onClick={onClickPrevious}>
            {listContent.boton[0].copy}
          </button>
        </aside>
      </article>
    </div>
  );
};

const ShiftRequestResult = memo(MemoShiftRequestResult);
export default ShiftRequestResult;
